module.exports = __webpack_public_path__ + "static/media/tabel-background.cf042e94.jpg";